import React from 'react';
import { 
    Container, 
    Row, 
    Col, 
    Card, 
    CardGroup, 
    CardHeader, 
    CardBody, 
    CardText 
} from 'react-bootstrap';

import { useDocumentModal } from '../DocumentModalContext/DocumentModalContext';

import 'bootstrap-icons/font/bootstrap-icons.css';
import "./Footer.css"

function Footer() {
    const { openModal } = useDocumentModal();

    return (
        <>
            <Container fluid id="kontakt" className="footerContainer">
                <Row className="flex-nowrap">
                    <Col>
                        <CardGroup>
                            <Card className="footerCard">
                                <Card.Header>KONTAKT</Card.Header>
                                <Card.Body>
                                    <Card.Text as="div">
                                        <p>
                                            <b>Polskie Stowarzyszenie Rodzin z Atrezją Przełyku</b><br />
                                            <i className="bi bi-envelope-at"></i> <a href="mailto:kontakt@przelyczki.org.pl">kontakt@przelyczki.org.pl</a>
                                        </p>
                                    </Card.Text>
                                </Card.Body>
                            </Card>
                            <Card className="footerCard">
                                <Card.Header>WAŻNE LINKI</Card.Header>
                                <Card.Body>
                                    <Card.Text as="div">
                                        <ul>
                                            <li>
                                                <a
                                                    className="importantLinks"
                                                    href="#"
                                                    onClick={(e) => {
                                                        e.preventDefault();
                                                        openModal('privacy');
                                                    }}
                                                >
                                                    Polityka Prywatności
                                                </a>
                                            </li>
                                            <li>
                                                <a
                                                    className="importantLinks"
                                                    href="#"
                                                    onClick={(e) => {
                                                        e.preventDefault();
                                                        openModal('rodo');
                                                    }}
                                                >
                                                    Klauzula informacyjna RODO
                                                </a>
                                            </li>
                                            <li>
                                                <a
                                                    className="importantLinks"
                                                    href="#"
                                                    onClick={(e) => {
                                                        e.preventDefault();
                                                        openModal('statute');
                                                    }}
                                                >
                                                    Regulamin Konferencji
                                                </a>
                                            </li>
                                        </ul>
                                    </Card.Text>
                                </Card.Body>
                            </Card>
                            <Card className="footerCard">
                                <Card.Header>SOCIAL MEDIA</Card.Header>
                                <Card.Body>
                                    <Card.Text>
                                        <a href="https://www.facebook.com/PrzelyczkiStowarzyszenie" className="socialMedia" target="_blank"><i className="bi bi-facebook"></i> Facebook</a>
                                        <br />
                                        <a href="https://www.instagram.com/przelyczki_stowarzyszenie/" className="socialMedia" target="_blank"><i className="bi bi-instagram"></i> Instagram</a>
                                    </Card.Text>
                                </Card.Body>
                            </Card>
                        </CardGroup>
                    </Col>
                </Row>
                <Row className="flex-nowrap">
                    <center><i className="bi bi-c-circle"></i> 2026. All Rights Reserved by Aleksander Klęczek (prywatnie tata Przełyczka)</center>
                </Row>
            </Container>
        </>
    );
}

export default Footer